import { useEffect } from "react";
import { enablePageTimerEnhancements } from "../constants/timers";

const useUserActivity = (onUserActive) => {
  useEffect(() => {
    const handleUserActivity = () => {
      if (onUserActive && typeof onUserActive === "function" && enablePageTimerEnhancements) {
        onUserActive(); // Call the callback function passed by the page
      }
    };

    // Attach event listeners
    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("mousedown", handleUserActivity);
    window.addEventListener("keypress", handleUserActivity);
    window.addEventListener("scroll", handleUserActivity);
    window.addEventListener("touchstart", handleUserActivity);
    window.addEventListener("pointerdown", handleUserActivity);

    // Cleanup
    return () => {
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("mousedown", handleUserActivity);
      window.removeEventListener("keypress", handleUserActivity);
      window.removeEventListener("scroll", handleUserActivity);
      window.removeEventListener("pointerdown", handleUserActivity);
    };
  }, [onUserActive]);
};

export default useUserActivity